/***********************/
/* Angular + external */
import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  forwardRef,
  SimpleChanges,
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

/***********************/
/* BFX */
import * as CubiqTS from "shared/cubiq-model-multi-asset";
// models

export const HOLD_STP_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ICHoldSTPComponent),
  multi: true,
};

@Component({
  selector: "ic-hold-stp",
  templateUrl: "./html/ic-hold-stp.html",
  providers: [HOLD_STP_VALUE_ACCESSOR],
  standalone: false,
})
export class ICHoldSTPComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {
  /**********************************************************************/
  /* INPUT */

  @Input() inputId: string;

  @Input("client") input_client: any;

  @Input("account") input_account: any;

  @Input("config") input_enabledConfig: any;

  @Input("label") input_label: any = "Hold STP";

  @Input("loading") isLoading: boolean = true;

  public onModelChange: Function = (value: any) => {};
  public onModelTouched: Function = () => {};

  /**********************************************************************/
  /* DATA */

  public data: any = {
    label: "Hold STP",
    enabled: false,
    value: null, // ExecutionType enum
    locked: false,
  };

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */

  constructor() {}

  /**********************************************************************/
  /* LIFE CYCLE HOOKS */
  ngOnInit() {
    this.initialize();
  }

  ngOnDestroy() {}

  ngOnChanges(changes: SimpleChanges) {
    this.onConstraintChanges(changes);
  }

  /**********************************************************************/
  /* INITIALIZATION */
  public initialize(): void {
    this.data.label = this.input_label;
  }

  /**********************************************************************/
  /* ControlValueAccessor */

  public writeValue(value: any): void {
    this.data.value = value;
    this.onModelChange(this.data.value);
  }

  public registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  public registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  /**********************************************************************/
  /* BASIC - API */

  public load(value: boolean): void {
    if (typeof value === "boolean" || value === null) {
      this.data.value = value;
    } else {
      logger.out.error(`ERROR: icHoldSTP.load(): failed to load '${value}'`);
    }
  }

  public reset(): void {
    this.data.value = null;
    this.data.locked = false;
  }

  public lock(): void {
    this.data.locked = true;
  }

  public unlock(): void {
    this.data.locked = false;
  }
  /**********************************************************************/
  /* ON CHANGES */

  public onConstraintChanges(changes: SimpleChanges): void {
    let relevantProps: boolean = false;
    for (let propName in changes) {
      if (propName == "input_client" || propName == "input_account") {
        relevantProps = true;
      }
    }
    if (relevantProps) {
      if (this.input_client == null) {
        if (!this.isLoading) {
          this.data.value = false;
        }
        this.data.enabled = false;
      } else if (this.input_account != null && this.isBreakAccount(this.input_account)) {
        // break account
        if (!this.isLoading) {
          this.data.value = true;
        }
        this.data.enabled = false;
      } else {
        // normal client account
        if (!this.isLoading) {
          this.data.value = false;
        }
        this.data.enabled = this.input_enabledConfig;
      }
      if (!this.isLoading) {
        this.onValueChange();
      }
    }
  }

  public onValueChange(): void {
    this.writeValue(this.data.value);
  }
  /**********************************************************************/
  /* ON CHANGES */

  private isBreakAccount(account: CubiqTS.AccountImpl): boolean {
    return account != null && (account.clientId == null || account.clientId === "");
  }
}
